import {
	FORGE_MODULE_ATTACHMENT_ACTION,
	FORGE_MODULE_BYLINE,
	FORGE_MODULE_CONTEXT_MENU,
	FORGE_MODULE_GLOBAL_SETTINGS,
	FORGE_MODULE_HOMEPAGE_FEED,
	FORGE_MODULE_SPACE_PAGE,
	FORGE_MODULE_SPACE_SETTINGS,
} from '../ForgeModuleType.ts';

const inlineDialog = {
	small: { width: '288px', height: '52px' },
	medium: { width: '288px', height: '112px' },
	large: { width: '400px', height: '262px' },
	get default() {
		return this.medium;
	},
};

const homepageFeed = {
	small: { width: '100%', height: '52px' },
	medium: { width: '100%', height: '112px' },
	large: { width: '100%', height: '262px' },
	xlarge: { width: '100%', height: '524px' },
	get default() {
		return this.medium;
	},
};

const spaceSettings = {
	default: { width: '100%', height: '65vh' },
};

const globalSettings = {
	default: { width: '100%', height: '75vh' },
};

const spacePage = {
	default: { width: '100%', height: '75vh' },
};

const sizes = {
	[FORGE_MODULE_ATTACHMENT_ACTION]: inlineDialog,
	[FORGE_MODULE_BYLINE]: inlineDialog,
	[FORGE_MODULE_CONTEXT_MENU]: inlineDialog,
	[FORGE_MODULE_GLOBAL_SETTINGS]: globalSettings,
	[FORGE_MODULE_HOMEPAGE_FEED]: homepageFeed,
	[FORGE_MODULE_SPACE_SETTINGS]: spaceSettings,
	[FORGE_MODULE_SPACE_PAGE]: spacePage,
};

const isPositivePixelSize = (value: unknown): value is string => {
	if (typeof value !== 'string' || !/^(?:\d+(?:\.\d+)?|\.\d+)px$/.test(value)) {
		return false;
	}
	const pixels = Number(value.slice(0, -2));
	return Number.isFinite(pixels) && pixels > 0;
};

export const calculateSize = (
	type: string,
	size?: unknown,
	extensionLocation?: unknown,
): { height: string; width: string } => {
	// Custom dimensions apply to attachment metadata popups, not action modals or other modules.
	if (
		type === FORGE_MODULE_ATTACHMENT_ACTION &&
		extensionLocation === 'metadata' &&
		typeof size === 'object' &&
		size !== null &&
		!Array.isArray(size) &&
		'width' in size &&
		'height' in size &&
		isPositivePixelSize(size.width) &&
		isPositivePixelSize(size.height)
	) {
		return { width: size.width, height: size.height };
	}

	const dimensions = sizes[type];
	if (!dimensions) {
		return { height: '100%', width: '100%' };
	}
	return typeof size === 'string' && Object.prototype.hasOwnProperty.call(dimensions, size)
		? dimensions[size]
		: dimensions.default;
};
